export const actions = {
    async submit({ state }, payload) {
        await this.$axios.delete(`/v2/application/price/${payload.id}`, payload.data);
    },
};
